<div class="container">
  <div class="mat-expansion-panel-header-container" [ngStyle]="containerStyle" *ngIf="allowTitleChange">
    <button mat-button type="button" class="edit-button btn-change" (click)="changeTitle()" *ngIf="allowTitleChange">
      <span>サービス変更 <mat-icon svgIcon="change"></mat-icon></span>
    </button>
  </div>
  <mat-expansion-panel
    class="mat-elevation-z0"
    [expanded]="!collapsed"
    [disabled]="!collapsed"
  >
    <mat-expansion-panel-header #expander>
      <div class="title-header" [class.nowrap]="allowTitleChange">
        <label>{{schedule.ttlnm}}</label>
      </div>
    </mat-expansion-panel-header>
    <div class="checkbox-field">
      <mat-checkbox [formControl]="summary" disableRipple (change)="onChange()"
        >サマリー</mat-checkbox
      >
      <mat-checkbox [formControl]="handover" disableRipple (change)="onChange()"
        >申し送り</mat-checkbox
      >
    </div>
    <app-datetime-field
      label="開始日時"
      [form]="startDate"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (formChange)="[onStartDateChange(), compareDate(), onChange()]"
    ></app-datetime-field>
    <app-datetime-field
      label="終了日時"
      [form]="endDate"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (formChange)="[compareDate(), onChange()]"
    >
      <mat-error *ngIf="endDate.hasError('compareDate')"
        >終了日時は開始日時より後の日時を入力してください</mat-error
      >
    </app-datetime-field>
    <app-status-field [form]="status"></app-status-field>
    <app-search-select-field
      *ngIf="hasStaffList"
      label="担当者1"
      [staffList]="staffList"
      [form]="odrstfcd"
      (staffChange)="[removeDuplicateVisitor($event), onChange()]"
    ></app-search-select-field>
    <app-search-select-field
      *ngIf="hasStaffList"
      label="担当者2"
      [staffList]="filterStaffList()"
      [form]="sndstfcd"
      [clear]="true"
      (staffChange)="onChange()"
    ></app-search-select-field>
    <hr />
  </mat-expansion-panel>
  <ng-container *ngIf="noteTitleParams">
    <lib-note-title [params]="noteTitleParams"></lib-note-title>
  </ng-container>
</div>
